import React, { Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { pxToRem, color } from '../../utils'
import { NavLink } from 'react-router-dom'
import { PlaceholderMenu } from '../loaders'
import statusDanger from '../../assets/icons/status-warning.svg'
import Logo from '../Logo'
import { menuActions } from '../../actions'

const Wrapper = styled.div`
  background: #fff;
  width: ${pxToRem('217px')};
  max-width: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  position: relative;
  align-self: stretch;
  min-height: calc(100% - ${pxToRem(104)});
  padding-top: ${pxToRem(104)};
  padding-bottom: ${pxToRem(120)};
  overflow-y: auto;
  z-index: 1;
  &::before {
    content: '';
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    width: ${pxToRem('217px')};
  }
  ul {
    padding: 0;
    margin: 0;
  }
  @media only screen and (max-width: 1000px) {
    display: none;
  }
`

const Item = styled.li`
  padding-left: 30px;
`

const NothingHere = styled.div`
  background: #fff;
  font-size: ${pxToRem(13.5)};
  text-align: center;
  padding: 2em 1em;
`

const MenuLink = styled(NavLink)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(14)};
  padding: ${pxToRem(37)} 0 ${pxToRem(37)} 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #9facb5;
  border-bottom: 1px solid #d8d8d8;
  > span {
    flex: 1;
    align-self: center;
    padding-right: ${pxToRem(10)};
  }
  &.menu-link-active {
    color: ${color.secondary};
    display: flex;
    &::after {
      content: '';
      transform: translate(${pxToRem('5px')});
      display: block;
      width: ${pxToRem(10)};
      height: ${pxToRem(10)};
      border-radius: 50%;
      background-color: ${color.secondary};
      box-shadow: 0 0 10px 0 ${color.secondary};
    }
  }
`

const MenuLinkLabel = MenuLink.withComponent('label')

const MenuLinkWithSub = styled(MenuLinkLabel)`
  ${({ active }) =>
    active
      ? `
    color: ${color.secondary};
    display: flex;
    &::after {
      content: '';
      transform: translate(${pxToRem('5px')});
      display: block;
      width: ${pxToRem(10)};
      height: ${pxToRem(10)};
      border-radius: 50%;
      background-color: ${color.secondary};
      box-shadow: 0 0 10px 0 ${color.secondary};
    }
  `
      : ''} cursor: pointer;
`

const WrapperNav = styled.div`
  box-sizing: border-box;
  min-height: 100%;
  width: 100%;
  ul {
    padding: 0;
    list-style: none;
  }
  nav {
    width: 100%;
    height: 100%;
    position: relative;
  }
`

const SubMenu = styled.ul`
  margin-top: -1px;
  ${Item} {
    margin-left: -30px;
    background: rgba(216, 216, 216, 0.3);
  }
`

const SubMenuLink = styled(NavLink)`
  display: inline-block;
  box-sizing: border-box;
  text-decoration: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: ${pxToRem(12)};
  padding: ${pxToRem(29)} ${pxToRem(29)} ${pxToRem(29)} 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #9facb5;
  border-bottom: 1px solid #d8d8d8;
  &.menu-link-active {
    color: ${color.secondary};
    position: relative;
  }
`

const ItemWithSubMenu = styled(Item)`
  input[type='checkbox'] {
    display: none;
  }
  ${SubMenu} {
    visibility: hidden;
    height: 0;
    width: 0;
    opacity: 0;
    transform: scaleY(0.8);
    transition: opacity 0.2s, transform 0.2s;
  }
  input[type='checkbox']:checked {
    & ~ ${SubMenu} {
      visibility: visible;
      height: auto;
      width: auto;
      opacity: 1;
      transform: scaleY(1);
      transform-origin: top;
    }
    & ~ ${MenuLinkWithSub} {
      border-bottom: none;
      color: ${color.secondary};
    }
  }
`

const WrapperLogo = styled.div`
  text-align: center;
  position: fixed;
  width: ${pxToRem(217)};
  bottom: 0;
  left: 0;
  padding: ${pxToRem(30)} 0;
  background: #fff;
`

const NothingHereIcon = styled.div`
  background: #5b666d;
  padding: ${pxToRem(5)};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  margin: auto;
`

class Sidebar extends React.PureComponent {
  componentDidMount() {
    this.props.fetchMenu()
  }

  openFile = () => {
    const { profile_document_url: url } = this.props
    window.open(url, '_blank')
  }

  render() {
    const { menuItems = [], profile_document_url, fetchingMenu, router, fetch_error } = this.props

    return (
      <Wrapper>
        <WrapperNav>
          <nav>
            {fetchingMenu ? (
              <PlaceholderMenu />
            ) : (
              <ul>
                {!menuItems.length ? (
                  <NothingHere>
                    <NothingHereIcon>
                      <img
                        src={statusDanger}
                        alt={'Você não possui permissões de acesso definidas.'}
                        aria-hidden="true"
                      />
                    </NothingHereIcon>

                    {!!fetch_error ? (
                      <Fragment>
                        <p>Falha ao tentar carregar o menu.</p>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <p>Você não possui permissões de acesso definidas.</p>
                        <p>Consulte o administrador do Sistema.</p>
                      </Fragment>
                    )}
                  </NothingHere>
                ) : (
                  menuItems.map(item => {
                    return item.subMenu ? (
                      <ItemWithSubMenu key={item.id}>
                        {!!router.location.pathname.includes(item.id) ? (
                          <input id={`sub-menu-${item.id}`} type="checkbox" defaultChecked />
                        ) : (
                          <input id={`sub-menu-${item.id}`} type="checkbox" />
                        )}
                        <MenuLinkWithSub
                          active={((router.location || {}).pathname || '').includes(item.id)}
                          htmlFor={`sub-menu-${item.id}`}
                        >
                          <span>{item.name}</span>
                        </MenuLinkWithSub>
                        <SubMenu>
                          {item.subMenu.map(subItem => (
                            <Item key={subItem.id}>
                              <SubMenuLink
                                to={`/${subItem.id}`}
                                activeClassName={'menu-link-active'}
                              >
                                {subItem.name}
                              </SubMenuLink>
                            </Item>
                          ))}
                        </SubMenu>
                      </ItemWithSubMenu>
                    ) : (
                      <Item key={item.id}>
                        <MenuLink to={`/${item.id}`} activeClassName={'menu-link-active'}>
                          <span>{item.name}</span>
                        </MenuLink>
                      </Item>
                    )
                  })
                )}
                <Item>
                  <MenuLink  to={''} onClick={() => window.open(process.env.REACT_APP_SUPPORT_URL, '_blank')}>
                    <span>Suporte</span>
                  </MenuLink>
                </Item>
                {(!!profile_document_url) &&
                <Item>
                  <MenuLink to={``} onClick={this.openFile}>
                    <span>Manual</span>
                  </MenuLink>
                </Item>
              }
              </ul>
            )}
          </nav>
        </WrapperNav>
        <WrapperLogo>
          <Logo name={'exo'} width={80} />
        </WrapperLogo>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => {
  return {
    profile_document_url: state.auth.profile_document_url,
    menuItems: state.menu.items,
    fetchingMenu: state.menu['is_fetching'],
    fetch_error: state.menu['fetch_error']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenu: () => {
      dispatch(menuActions.fetchMenu())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js